/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect, useRef, useMemo } from "react";
import "./Navbar.css";
import logo from "../../images/DOTMEDICA.png";
import { fetchFullMainMenu, MainMenu } from "src/network/fetchFullMainMenu";
import { pageUrl } from "src/network/fullUrl";
import MenuItem from "./MenuItem";
import { useIsMobile } from "src/hooks/useIsMobile";
import { Link, Navigate, useNavigate } from "react-router-dom";

interface NavbarProps {
  isMenuOpen: boolean;
  hideMenuLogo?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ isMenuOpen, hideMenuLogo }) => {
  const navbarRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState<MainMenu[]>([
    { label: "about", url: "/about" },
    {
      label: "services",
      url: "/",
      subMenu: [
        { label: "offshore medicine", url: "/offshore-medicine" },
        { label: "diving medicine", url: "/diving-medicine" },
        { label: "maritime medicine", url: "/maritime-medicine" },
        { label: "occupational health", url: "/occupational-health" },
        { label: "health surveillance", url: "/health-surveillance" },
        { label: "onsite assessment", url: "/onsite-assessment" },
        { label: "hbot", url: "/hbot" },
        { label: "training center", url: "/training-center" },
      ],
    },
    { label: "news", url: "/news" },
    { label: "partners", url: "/partners" },
    { label: "contact", url: "/#contact-us" },
  ]);

  const { isMobile } = useIsMobile();

  const flattenedMenuItems = useMemo(
    () =>
      menuItems.flatMap((menuItem) => {
        // Include the main menu item
        const mainItem = { label: menuItem.label, url: menuItem.url };

        // Include subMenu items if they exist
        const subMenuItems =
          menuItem.subMenu?.map((subItem) => ({
            label: subItem.label,
            url: subItem.url,
          })) || [];

        // Combine main item and subMenu items
        return [mainItem, ...subMenuItems];
      }),
    [menuItems]
  );

  // useEffect(() => {
  //   const getMenuItems = async () => {
  //     try {
  //       const items = await fetchFullMainMenu();
  //       setMenuItems(items);
  //     } catch (error) {
  //       console.error("Failed to fetch Certificates:", error);
  //     }
  //   };

  //   getMenuItems();
  // }, [setMenuItems]);

  return (
    <nav className="navbar" ref={navbarRef}>
      {!hideMenuLogo && (
        <img
          src={logo}
          alt="Logo"
          className="logo"
          onClick={() => navigate("/")}
        />
      )}

      <ul
        className={`nav-menu ${isMenuOpen ? "open" : ""}`}
        aria-hidden={!isMenuOpen}
      >
        {menuItems.map((menuItem) => {
          return <MenuItem key={menuItem.label} menuItem={menuItem} />;
        })}

        {isMobile &&
          flattenedMenuItems.map((menuItem) => {
            return (
              <li key={`nav-link sub-menu-mobile-${menuItem.url}`}>
                <Link to={menuItem.url} className={"nav-sub-link"}>
                  {menuItem.label}
                </Link>
              </li>
            );
          })}
        {/* <li className="services-link">
          <ul className="services-content">
            {services.map((service) => (
              <li key={`sub-menu-mobile-${service.link}`}>
                <a href={fullUrl(service.link)} className={"nav-sub-link"}>
                  {service.title}
                </a>
              </li>
            ))}
          </ul>
        </li> */}
      </ul>
    </nav>
  );
};

export default Navbar;
